import FigureSelect from "./FigureSelect";

export default FigureSelect;